<template>
<div class="chapter">
<div class="inner_page">
<div class="boxg">
<h1 class="part-no" id="pt-1"><strong><a id="page_3">Part One</a></strong></h1><a id="page_3">
</a></div><a id="page_3">
</a><h1 class="part-title"><a id="page_3"><em>Politics vs. Economics in Public Finance</em></a><a id="page_4"></a></h1><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Part01.vue?813520c4